import $ from 'jquery';

const $bar = $( '.js-post-bar' );
const $barHeight = $bar.outerHeight();
const $triggerOn = $( '.js-post-bar-trigger-on' );
const $triggerOff = $( '.js-post-bar-trigger-off' );

if ( $bar.length ) {
	const triggerOnPosition = Math.ceil(
		$triggerOn.position().top - $( window ).height()
	);

	const triggerOffPosition = Math.ceil(
		$triggerOff.position().top - $( window ).height() + $barHeight
	);

	$( window ).on( 'scroll', function() {
		const $self = $( this );

		if ( $self.scrollTop() > triggerOnPosition ) {
			$bar.removeClass( 'is-static' ).addClass( 'is-visible' );
		}

		if ( $self.scrollTop() == 0 ) {
			$bar.removeClass( 'is-visible' );
		}
		
		if ( $self.scrollTop() > triggerOffPosition ) {
			$bar.removeClass( 'is-visible' ).addClass( 'is-static' );
		}
	} );
}
